/* auth actions */
export const AUTH_ACTION_LOGIN = 'AUTH_ACTION_LOGIN';
export const AUTH_ACTION_LOGOUT = 'AUTH_ACTION_LOGOUT';
export const AUTH_ACTION_MY_INFO = 'AUTH_ACTION_MY_INFO';
export const AUTH_ACTION_BUY_ELEVATOR = 'AUTH_ACTION_BUY_ELEVATOR';


/* vehicle filter actions */
export const VEHICLE_FILTER_UPDATE_TERM = "VEHICLE_FILTER_UPDATE_TERM";
export const VEHICLE_FILTER_CLEAR_CATEGORY = "VEHICLE_FILTER_CLEAR_CATEGORY";
export const VEHICLE_FILTER_UPDATE_CATEGORY = "VEHICLE_FILTER_UPDATE_CATEGORY";
export const VEHICLE_FILTER_PAGE_NEXT = "VEHICLE_FILTER_PAGE_NEXT";
export const VEHICLE_FILTER_PAGE_PREV = "VEHICLE_FILTER_PAGE_PREV";

/* vehicle configs */
export const VEHICLE_CONFIG_FETCH = "VEHICLE_CONFIG_FETCH";
export const VEHICLE_CONFIG_BRAND = "VEHICLE_CONFIG_BRAND";
export const VEHICLE_CONFIG_VEHICLE = "VEHICLE_CONFIG_VEHICLE";
export const VEHICLE_CONFIG_CITY = "VEHICLE_CONFIG_CITY";
export const VEHICLE_CONFIG_SPECIAL_CATEGORY = "VEHICLE_CONFIG_SPECIAL_CATEGORY";
export const VEHICLE_CONFIG_FAVOURITE_VEHICLES_FETCH = "VEHICLE_CONFIG_FAVOURITE_VEHICLES_FETCH";

/* vehicle ads */
export const VEHICLE_ADS_FETCH = "VEHICLE_ADS_FETCH";
export const VEHICLE_ADS_LIST_CLEAR = "VEHICLE_ADS_LIST_CLEAR";
export const VEHICLE_ADS_DETAILS_CLEAR = "VEHICLE_ADS_DETAILS_CLEAR";
export const VEHICLE_ADS_DETAILS_FETCH = "VEHICLE_ADS_DETAILS_FETCH";
export const VEHICLE_ADS_ADD_TO_FAVOURITE = "VEHICLE_ADS_ADD_TO_FAVOURITE";
export const VEHICLE_ADS_REMOVE_FROM_FAVOURITE = "VEHICLE_ADS_REMOVE_FROM_FAVOURITE";
export const VEHICLE_ADS_REPORT = "VEHICLE_ADS_REPORT";

/* job filter actions */
export const JOB_FILTER_UPDATE_TERM = "JOB_FILTER_UPDATE_TERM";
export const JOB_FILTER_UPDATE_CATEGORY = "JOB_FILTER_UPDATE_CATEGORY";
export const JOB_FILTER_PAGE_NEXT = "JOB_FILTER_PAGE_NEXT";
export const JOB_FILTER_PAGE_PREV = "JOB_FILTER_PAGE_PREV";

/* job ads */
export const JOB_ADS_FETCH = "JOB_ADS_FETCH";
export const JOB_ADS_DETAILS_CLEAR = "JOB_ADS_DETAILS_CLEAR";
export const JOB_ADS_DETAILS_FETCH = "JOB_ADS_DETAILS_FETCH";
export const JOB_ADS_ADD_TO_FAVOURITE = "JOB_ADS_ADD_TO_FAVOURITE";
export const JOB_ADS_REMOVE_FROM_FAVOURITE = "JOB_ADS_REMOVE_FROM_FAVOURITE";
export const JOB_ADS_REPORT = "JOB_ADS_REPORT";

/*job configs */
export const JOB_CONFIG_JOB_TYPES_FETCH = 'JOB_CONFIG_JOB_TYPES_FETCH';
export const JOB_CONFIG_FAVOURITE_JOBS_FETCH = 'JOB_CONFIG_FAVOURITE_JOBS_FETCH';

/* shared configs */
export const CROSS_CONFIG_STATES = 'CROSS_CONFIG_STATES';
export const CROSS_CONFIG_CITIES = 'CROSS_CONFIG_CITIES';
export const CROSS_CONFIG_GALLERIES = 'CROSS_CONFIG_GALLERIES';
export const CROSS_CONFIG_AGENCIES = 'CROSS_CONFIG_AGENCIES';

/* agency configs */
export const AGENCY_CONFIG_COMPANY = 'AGENCY_CONFIG_COMPANY';
export const AGENCY_CONFIG_USER_AGENCIES = 'AGENCY_CONFIG_USER_AGENCIES';

/* agency ads */
export const AGENCY_ADS_FETCH = "AGENCY_ADS_FETCH";

/* gallery configs */
export const GALLERY_CONFIG_WORKING_CONTEXT = 'GALLERY_CONFIG_WORKING_CONTEXT';
export const GALLERY_CONFIG_USER_GALLERIES = 'GALLERY_CONFIG_USER_GALLERIES';

/* gallery ads */
export const GALLERY_ADS_FETCH = "GALLERY_ADS_FETCH";

/* gallery details filter actions */
export const GALLERY_DETAILS_FILTER_PAGE_NEXT = "GALLERY_DETAILS_FILTER_PAGE_NEXT";
export const GALLERY_DETAILS_FILTER_PAGE_PREV = "GALLERY_DETAILS_FILTER_PAGE_PREV";
export const GALLERY_DETAILS_FILTER_PAGE_RESET = "GALLERY_DETAILS_FILTER_PAGE_RESET";

/* gallery detail info actions */
export const GALLERY_DETAIL_RESET = "GALLERY_DETAIL_RESET";
export const GALLERY_DETAIL_INFO_FETCH = "GALLERY_DETAIL_INFO_FETCH";
export const GALLERY_DETAIL_ADS_FETCH = "GALLERY_DETAIL_ADS_FETCH";

/* agency filter actions */
export const AGENCY_FILTER_UPDATE_TERM = "AGENCY_FILTER_UPDATE_TERM";
export const AGENCY_FILTER_UPDATE_CATEGORY = "AGENCY_FILTER_UPDATE_CATEGORY";
export const AGENCY_FILTER_PAGE_NEXT = "AGENCY_FILTER_PAGE_NEXT";
export const AGENCY_FILTER_PAGE_PREV = "AGENCY_FILTER_PAGE_PREV";

/* alarm detail info actions */
export const ALARM_DETAIL_RESET = "ALARM_DETAIL_RESET";
export const ALARM_DETAILS_FETCH = "ALARM_DETAILS_FETCH";
export const ALARM_ADS_FETCH = "ALARM_ADS_FETCH";

/* agency detail info actions */
export const AGENCY_DETAIL_RESET = "AGENCY_DETAIL_RESET";
export const AGENCY_DETAIL_INFO_FETCH = "AGENCY_DETAIL_INFO_FETCH";
export const AGENCY_DETAIL_ADS_FETCH = "AGENCY_DETAIL_ADS_FETCH";

/* alarm details filter actions */
export const ALARM_DETAILS_FILTER_PAGE_NEXT = "ALARM_DETAILS_FILTER_PAGE_NEXT";
export const ALARM_DETAILS_FILTER_PAGE_PREV = "ALARM_DETAILS_FILTER_PAGE_PREV";
export const ALARM_DETAILS_FILTER_PAGE_RESET = "ALARM_DETAILS_FILTER_PAGE_RESET";

/* agency details filter actions */
export const AGENCY_DETAILS_FILTER_PAGE_NEXT = "AGENCY_DETAILS_FILTER_PAGE_NEXT";
export const AGENCY_DETAILS_FILTER_PAGE_PREV = "AGENCY_DETAILS_FILTER_PAGE_PREV";
export const AGENCY_DETAILS_FILTER_PAGE_RESET = "AGENCY_DETAILS_FILTER_PAGE_RESET";

/* gallery filter actions */
export const GALLERY_FILTER_UPDATE_TERM = "GALLERY_FILTER_UPDATE_TERM";
export const GALLERY_FILTER_UPDATE_CATEGORY = "GALLERY_FILTER_UPDATE_CATEGORY";
export const GALLERY_FILTER_PAGE_NEXT = "GALLERY_FILTER_PAGE_NEXT";
export const GALLERY_FILTER_PAGE_PREV = "GALLERY_FILTER_PAGE_PREV";

/* dashboard data lists */
export const DASHBOARD_VEHICLE_REMOVE = "DASHBOARD_VEHICLE_REMOVE";
export const DASHBOARD_JOB_REMOVE = "DASHBOARD_JOB_REMOVE";
export const DASHBOARD_AGENCY_REMOVE = "DASHBOARD_AGENCY_REMOVE";
export const DASHBOARD_GALLERY_REMOVE = "DASHBOARD_GALLERY_REMOVE";
export const DASHBOARD_ALARM_REMOVE = "DASHBOARD_ALARM_REMOVE";
export const DASHBOARD_PAGE_NEXT = "DASHBOARD_PAGE_NEXT";
export const DASHBOARD_PAGE_PREV = "DASHBOARD_PAGE_PREV";
export const DASHBOARD_PAGE_SET_DATA = "DASHBOARD_PAGE_SET_DATA";
export const DASHBOARD_RESET = "DASHBOARD_RESET";
export const DASHBOARD_ELEVATE_SUCCESS = "DASHBOARD_ELEVATE_SUCCESS";